import {CommonModule} from '@angular/common'
import {NgModule} from '@angular/core'
import {TrimPipe} from '../@theme/pipes'
import {NbButtonModule, NbCardModule, NbCheckboxModule, NbDialogModule, NbIconModule, NbSpinnerModule, NbTooltipModule, NbRadioModule, NbSelectModule} from '@nebular/theme'
import {TranslateModule} from '@ngx-translate/core'
import {NbEvaIconsModule} from '@nebular/eva-icons'
import {FocusRemover} from '../@theme/directives/foocus-remover.directive'

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NbCardModule,
    NbButtonModule,
    NbIconModule,
    NbEvaIconsModule,
    NbCheckboxModule,
    NbTooltipModule,
    NbDialogModule.forRoot(),
    NbSpinnerModule,
    NbRadioModule,
    NbSelectModule
  ],
  declarations: [
    TrimPipe,
    FocusRemover
  ],
  exports: [
    TranslateModule,
    NbCardModule,
    NbButtonModule,
    NbDialogModule,
    NbIconModule,
    NbEvaIconsModule,
    NbCheckboxModule,
    NbDialogModule,
    NbTooltipModule,
    NbSpinnerModule,
    NbRadioModule,
    NbSelectModule,
    TrimPipe,
    FocusRemover
  ]
})
export class SharedModule {}
